import {autoserializeAs} from "dcerialize";

export class ContactFormSender {
  @autoserializeAs(() => String)
  public email: string;
  @autoserializeAs(() => String)
  public name: string;

  public constructor(email: string, name: string) {
    this.email = email;
    this.name = name;
  }
}
